module.exports = __webpack_public_path__ + "img/11.68e7b6e0.jpeg";